import { NavLink } from 'react-router-dom';
import { Sun, MessageCircle, Inbox, CalendarDays, Sparkles } from 'lucide-react';
import { cn } from '@/lib/cn';

/**
 * LA BARRA INFERIOR — las cinco pestañas, sólo en móvil.
 *
 * Mandato: *"Móvil: barra inferior fija de 5 pestañas — Hoy · Agenda · Me
 * toca · Personas · Athena."*
 *
 * ═══ POR QUÉ CINCO Y NO LAS QUE HAYA ═══
 *
 * La barra NO se arma del menú del servidor. Son estas cinco, fijas. El menú
 * del servidor decide qué módulos tiene el inquilino; la barra decide cómo se
 * navega este producto. Si se armara del menú, un módulo nuevo metería una
 * sexta pestaña y la barra dejaría de ser predecible — y una barra de
 * navegación que cambia de forma es una barra que hay que leer cada vez.
 *
 * ═══ EL ÁREA SEGURA DEL TELÉFONO ═══
 *
 * `env(safe-area-inset-bottom)` evita que la barra quede debajo del indicador
 * de inicio del iPhone. Sin eso, la última fila de píxeles no se puede tocar.
 */

//
// `Chats` entro el 20-sep y `Personas` salio, por un pedido concreto:
// *"no veo el chat en vivo dentro del programa"*. A Personas se llega desde
// un chat, desde un asunto o con el buscador; a los chats habia que llegar
// por el sidebar, que en el telefono no existe.
//
// Siguen siendo cinco. Una sexta pestana en 390 px deja etiquetas de dos
// lineas o iconos sin texto, y las dos cosas se leen peor que cinco.
const PESTANAS = [
  { a: '/', etiqueta: 'Hoy', Icono: Sun },
  { a: '/chats', etiqueta: 'Chats', Icono: MessageCircle },
  { a: '/me-toca', etiqueta: 'Me toca', Icono: Inbox },
  { a: '/agenda', etiqueta: 'Agenda', Icono: CalendarDays },
  { a: '/athena', etiqueta: 'Athena', Icono: Sparkles },
];

export function BarraInferior() {
  return (
    <nav
      aria-label="Navegación principal"
      className="fixed inset-x-0 bottom-0 z-30 border-t border-slate-200 bg-white/95 backdrop-blur md:hidden dark:border-slate-800 dark:bg-slate-900/95"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <ul className="flex">
        {PESTANAS.map(({ a, etiqueta, Icono }) => (
          <li key={a} className="flex-1">
            <NavLink
              to={a}
              end={a === '/'}
              className={({ isActive }) =>
                cn(
                  // 56 px de alto: por encima del mínimo de 44 que pide el
                  // mandato, porque acá el dedo llega de costado.
                  'flex min-h-[56px] flex-col items-center justify-center gap-0.5 text-[11px] transition',
                  isActive
                    ? 'text-violet-600 dark:text-violet-300'
                    : 'text-slate-500 dark:text-slate-400',
                )
              }
            >
              {({ isActive }) => (
                <>
                  <Icono className={cn('h-5 w-5', isActive && 'stroke-[2.5]')} />
                  {etiqueta}
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
